import React, { useEffect, useState } from "react";
import { Spinner, Table, Tag } from "components";
import { helpers } from "services";
import qs from "qs";
import StoreActions from "store/actions/system";
import EntityActions from "modules/entity/actions";
import { useDispatch, useSelector } from "react-redux";
import Filter from "pages/Reports/reportDishes/filter";
import DateFilterWrap from "components/DateFilter/wrap";
import config from "config";
import dayjs from "dayjs";
import { groupBy } from "lodash";
import Item from "pages/Reports/reportDishes/item";
import useTranslation from "hooks/useTranslation";
import DownloadFile from "components/DownloadFile";
import { useLocation } from "react-router-dom";

function MainOrganizationReportDishes() {
  const { tr } = useTranslation();
  const location = useLocation();
  const [isFetched, setIsFetched] = useState(true);
  const [openedRows, setOpenedRows] = useState([]);

  const [totalComingSum, setTotalComingSum] = useState(0);
  const [totalSum, setTotalSum] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [productIds, setProductIds] = useState([]);
  const [groupData, setGroupData] = useState(null);

  const [comboItems, setComboItems] = useState([]);
  const [totalComingSumCombo, setTotalComingSumCombo] = useState(0);
  const [totalSumCombo, setTotalSumCombo] = useState(0);
  const [totalQuantityCombo, setTotalQuantityCombo] = useState(0);

  const defaultCurrency = useSelector(state => state.auth.default_currency_code);
  const { page, start_at, end_at, ...params } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const filterValues = params.filter ? JSON.parse(params.filter) : null;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(StoreActions.SetToolbarTitle(tr("Отчёты")));
  }, []);

  useEffect(() => {
    setIsFetched(false);
    dispatch(
      EntityActions.LoadDefault.request({
        url: "/main/reports/dishes",
        params: {
          extra: {
            name: filterValues ? filterValues.name : "",
            kitchener_ids: filterValues && filterValues.kitcheners.reduce((prev, curr) => [...prev, curr.id], []).join(","),
            product_ids: filterValues && filterValues.products.reduce((prev, curr) => [...prev, curr.id], []).join(","),
            user_ids: filterValues && filterValues.authors.reduce((prev, curr) => [...prev, curr.id], []).join(","),
            category_ids: filterValues && filterValues.categories.reduce((prev, curr) => [...prev, curr.id], []).join(","),
            start_at: start_at
              ? start_at
              : dayjs()
                .startOf("day")
                .unix(),
            end_at: end_at
              ? end_at
              : dayjs()
                .endOf("day")
                .unix(),
            order_types: filterValues && filterValues.order_types.reduce((prev, curr) => [...prev, curr.id], []).join(","),
            order_statuses: filterValues && filterValues.order_statuses.reduce((prev, curr) => [...prev, curr.id], []).join(","),
          },
        },
        cb: {
          success: response => {
            const data = response.filter(r => r.is_set !== 1);
            const comboData = response.filter(r => r.is_set === 1);
            setComboItems(comboData);

            const a = groupBy(data, "product_id");
            setGroupData(a);
            setProductIds(Object.keys(a));

            const totalSum = data.reduce((prev, curr) => prev + Number(curr.sum), 0);
            const totalQuantity = data.reduce((prev, curr) => prev + Number(curr.quantity), 0);
            const totalSumComing = data.reduce((prev, curr) => prev + Number(curr.coming_price), 0);

            setTotalSum(totalSum);
            setTotalQuantity(totalQuantity);
            setTotalComingSum(totalSumComing);

            // combo
            const totalSumC = comboData.reduce((prev, curr) => prev + Number(curr.sum), 0);
            const totalQuantityC = comboData.reduce((prev, curr) => prev + Number(curr.quantity), 0);
            const totalSumComingC = comboData.reduce((prev, curr) => prev + Number(curr.coming_price), 0);

            setTotalSumCombo(totalSumC);
            setTotalQuantityCombo(totalQuantityC);
            setTotalComingSumCombo(totalSumComingC);

            setTimeout(() => {
              setIsFetched(true);
            }, 500);
          },
          error: () => {
            setIsFetched(true);
          },
        },
      })
    );
  }, [params.filter, start_at, end_at]);

  const toggleClosedKeys = rowKey => {
    const isOpened = openedRows.find(o => o === rowKey);
    if (isOpened) {
      const arr = openedRows.filter(o => o !== rowKey);
      setOpenedRows(arr);
    } else {
      setOpenedRows([...openedRows, rowKey]);
    }
  };

  return (
    <div className="d-panel">
      <div className="d-flex align-items-center justify-content-between mb-10">
        <div className="main-title mb-0">{tr("Отчёт по продуктам")}</div>
        <div className="d-flex">
          <DateFilterWrap dropdownPosition={"right"} className="mr-10" withStartHoursAppended={true}
						navigateByDay={true} />
          <DownloadFile
            api={"/main/reports/dishes"}
            filename={"Отчёт по продуктам.xlsx"}
            params={{
              extra: {
                _excel: "1",
                name: filterValues ? filterValues.name : "",
                kitchener_ids: filterValues && filterValues.kitcheners.reduce((prev, curr) => [...prev, curr.id], []).join(","),
                product_ids: filterValues && filterValues.products.reduce((prev, curr) => [...prev, curr.id], []).join(","),
                user_ids: filterValues && filterValues.authors.reduce((prev, curr) => [...prev, curr.id], []).join(","),
                category_ids: filterValues && filterValues.categories.reduce((prev, curr) => [...prev, curr.id], []).join(","),
                start_at: start_at
                  ? start_at
                  : dayjs()
                    .startOf("day")
                    .unix(),
                end_at: end_at
                  ? end_at
                  : dayjs()
                    .endOf("day")
                    .unix(),
                order_types: filterValues && filterValues.order_types.reduce((prev, curr) => [...prev, curr.id], []).join(","),
                order_statuses: filterValues && filterValues.order_statuses.reduce((prev, curr) => [...prev, curr.id], []).join(","),
              },
            }}
          />
        </div>
      </div>

      <Filter />

      {isFetched ? (
        <>
          <div className="with-bg">
            <div className="devent-table">
              <table>
                <thead>
                  <tr>
                    <th>{tr("Название")}</th>
                    <th>{tr("Ед изм")}</th>
                    <th className="text-cen">{tr("Кол-во")}</th>
                    <th className="ws-no-wrap text-right">{tr("Цена")}</th>
                    <th className="ws-no-wrap text-right">{tr("Сумма")}</th>
                    <th className="ws-no-wrap text-right">{tr("Себестоимость")}</th>
                    <th className="ws-no-wrap text-right">{tr("Прибыль")}</th>
                    <th className="ws-no-wrap w-150">{tr("Статус")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-600">{tr("Итого")}</td>
                    <td></td>
                    <td className="fw-600 text-cen">{helpers.convertToReadable(totalQuantity)}</td>
                    <td></td>
                    <td className="fw-600 text-right">
                      {helpers.convertToReadable(totalSum)} {defaultCurrency && defaultCurrency.toUpperCase()}
                    </td>
                    <td className="fw-600 text-right">
                      {helpers.convertToReadable(totalComingSum)} {defaultCurrency && defaultCurrency.toUpperCase()}
                    </td>
                    <td className="fw-600 text-right">
                      {helpers.convertToReadable(totalSum - totalComingSum)} {defaultCurrency && defaultCurrency.toUpperCase()}
                    </td>
                    <td></td>
                  </tr>
                  {productIds.map((id, i) => {
                    const arr = groupData[id];
                    const hasChild = arr.length > 1;

                    const item = arr[0];
                    const price = item.price ? Number(item.price) : 0;
                    const comingPrice = item.coming_price ? Number(item.coming_price) : 0;
                    const sum = item.sum ? Number(item.sum) : 0;
                    const profit = sum - comingPrice;
                    const setProductName = item.set_product;

                    return hasChild ? (
                      <Item list={arr} ind={i} {...{ defaultCurrency, toggleClosedKeys, openedRows }} />
                    ) : (
                      <tr>
                        <td>
                          <span className="ws-no-wrap" style={{ color: "#2a85ff" }}>
                            {i + 1}. {item.name} {setProductName && ` (${setProductName})`}
                          </span>
                        </td>
                        <td>{item.unit}</td>
                        <td className="text-cen">{item.quantity}</td>
                        <td className={"ws-no-wrap text-right"}>
                          {helpers.convertToReadable(price)} {defaultCurrency && defaultCurrency.toUpperCase()}
                        </td>
                        <td className="ws-no-wrap text-right">
                          {helpers.convertToReadable(sum)} {defaultCurrency && defaultCurrency.toUpperCase()}
                        </td>
                        <td className="ws-no-wrap text-right">
                          {helpers.convertToReadable(comingPrice)} {defaultCurrency && defaultCurrency.toUpperCase()}
                        </td>
                        <td className="ws-no-wrap text-right">
                          {helpers.convertToReadable(profit)} {defaultCurrency && defaultCurrency.toUpperCase()}
                        </td>
                        <td>
                          {item.status === 1 ? (
                            <Tag color={"green"}>{tr("Завершено")}</Tag>
                          ) : (
                            <Tag color={"blue"}>{tr("В процессе")}</Tag>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-30 main-title mb-10">{tr("Сет")}</div>
          <div className="with-bg">
            <Table
              items={comboItems}
              isFetched={isFetched}
              totalRowPrepend={
                <tr>
                  <td className="fw-600">{tr("Всего")}</td>
                  <td></td>
                  <td className="fw-600 text-cen">{helpers.convertToReadable(totalQuantityCombo)}</td>
                  <td></td>
                  <td className="fw-600 text-right">
                    {helpers.convertToReadable(totalSumCombo)} {defaultCurrency && defaultCurrency.toUpperCase()}
                  </td>
                  <td className="fw-600 text-right">
                    {helpers.convertToReadable(totalComingSumCombo)} {defaultCurrency && defaultCurrency.toUpperCase()}
                  </td>
                  <td className="fw-600 text-right">
                    {helpers.convertToReadable(totalSumCombo - totalComingSumCombo)} {defaultCurrency && defaultCurrency.toUpperCase()}
                  </td>
                  <td></td>
                </tr>
              }
              columns={[
                {
                  title: tr("Название"),
                  dataIndex: "name",
                  render: value => (
                    <div>
                      <div>{value}</div>
                    </div>
                  ),
                },
                {
                  title: tr("Ед изм"),
                  dataIndex: "unit",
                  render: value => <div className="ws-no-wrap">{value}</div>,
                },
                {
                  title: tr("Кол-во"),
                  dataIndex: "quantity",
                  className: "text-cen",
                  render: value => <div className="ws-no-wrap text-cen">{value ? value : 0}</div>,
                },
                {
                  title: tr("Цена"),
                  dataIndex: "price",
                  className: "ws-no-wrap text-right",
                  render: value => (
                    <div className="text-right">
                      {helpers.convertToReadable(value ? Number(value) : 0)} {defaultCurrency && defaultCurrency.toUpperCase()}
                    </div>
                  ),
                },
                {
                  title: tr("Сумма"),
                  dataIndex: "sum",
                  className: "ws-no-wrap text-right",
                  render: value => (
                    <div className="text-right">
                      {helpers.convertToReadable(value ? Number(value) : 0)} {defaultCurrency && defaultCurrency.toUpperCase()}
                    </div>
                  ),
                },
                {
                  title: tr("Себестоимость"),
                  dataIndex: "coming_price",
                  className: "ws-no-wrap text-right",
                  render: value => (
                    <div className="text-right">
                      {helpers.convertToReadable(value ? Number(value) : 0)} {defaultCurrency && defaultCurrency.toUpperCase()}
                    </div>
                  ),
                },
                {
                  title: tr("Прибыль"),
                  dataIndex: "coming_price",
                  className: "ws-no-wrap text-right",
                  render: (value, row) => {
                    const a = value ? Number(value) : 0;
                    const b = row.sum ? Number(row.sum) : 0;
                    const c = b - a;
                    return (
                      <div className="text-right">
                        {helpers.convertToReadable(c)} {defaultCurrency && defaultCurrency.toUpperCase()}
                      </div>
                    );
                  },
                },
                {
                  title: tr("Статус"),
                  dataIndex: "status",
                  className: "ws-no-wrap w-150",
                  render: value => (
                    <div>
                      {value === 1 ? (
                        <Tag color={"green"}>{tr("Завершено")}</Tag>
                      ) : (
                        <Tag color={"blue"}>{tr("В процессе")}</Tag>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </>
      ) : (
        <Spinner position={"center"} />
      )}
    </div>
  );
}

export default MainOrganizationReportDishes;
